<strong>{{ fieldTitle() }}: {{ value() || 'N/A' }}</strong>
<span>
  (Count: {{ dataItem().count || group()?.items?.length || 0 }}, Total:
  {{ formattedCurrency() }})
</span>
